// extracted by mini-css-extract-plugin
module.exports = {"selecionado":"Plano_selecionado__2Csqz"};